import { defineMessages } from 'react-intl';

const messages = defineMessages({
  bank_name: '开户行',
  bank_number: '银行账户',
  invoice_type: '发票类型',
});

export default messages;
